import { Actor, HttpAgent } from '@dfinity/agent';
import { AuthClient } from "@dfinity/auth-client";
import { sha224 } from '@dfinity/principal/lib/esm/utils/sha224';
import { getCrc32 } from '@dfinity/principal/lib/esm/utils/getCrc';
import { Principal } from "@dfinity/principal"; 
import { StoicIdentity } from "./stoicIdentity";
import _ from 'json-bigint';

var popupS = require('popups');

//Finance Canister Test hjhxd-tqaaa-aaaaf-qaeja-cai
//Finance Canister Production  hhf2l-iaaaa-aaaaf-qaeia-cai
// Canister Id as an example
const MarsPoolNFTId = 'lqrjy-ayaaa-aaaai-abfpq-cai';
const financeCanisterID = 'hhf2l-iaaaa-aaaaf-qaeia-cai'; 
const LEDGER_CANISTER_ID = "ryjl3-tyaaa-aaaaa-aaaba-cai";


let MarsPoolNFTActor = null;
let ledgerActor = null;
let financeActor = null;
let identity = null;
let mintProgress = false;
let nextAccountID = null;
let currentConnectWallet = 0; // 1 = Plug-Wallet 2=StoicWallet
let mintFee = null;
let transferAccountID = null;
let decimals = 100000000;
var balanceICP = null;
var isMintedFlag = false;
var link = "";
var metaDataList = "";
var animationCreated = false;

/***********************************************************************/
document.getElementById("seed").style.display = "none";
document.getElementById("load").style.display = "none";
document.getElementById("checknow").style.display = "none";
document.getElementById("logtxt").style.display = "none";
document.getElementById("mintnow").style.display = "none";
document.getElementById("allmetadata").style.display = "none";
/***********************************************************************/

const agent = new HttpAgent();
let principal = new Principal();
var principalId;

const whitelist = [LEDGER_CANISTER_ID,financeCanisterID,MarsPoolNFTId];
const host = "https://mainnet.dfinity.network";

const MarsPoolNFTFactory = ({ IDL }) => {
  const ClaimRequest_2 = IDL.Record({
    'metadata' : IDL.Text,
    'amountPaid' : IDL.Nat64,
    'account' : IDL.Text,
    'blockHeight' : IDL.Nat64,
    'rarity' : IDL.Text,
  });
  const AccountIdentifier_2 = IDL.Text;
  const AccountIdentifier = AccountIdentifier_2;  
  const User = IDL.Variant({
    'principal' : IDL.Principal,
    'address' : AccountIdentifier,
  });
  const TokenIndex_2 = IDL.Nat32;
  const ClaimRequest = ClaimRequest_2;
  const TokenIndex = TokenIndex_2;
  const TokenStatistics_2 = IDL.Record({
    'claimed' : IDL.Nat32,
    'available' : IDL.Nat32,
    'supply' : IDL.Nat,
  });
  const TokenStatistics = TokenStatistics_2;
    return IDL.Service({
      'claimNFT' : IDL.Func([ClaimRequest], [TokenIndex], []),
      'user_tokens' : IDL.Func([User], [IDL.Vec(TokenIndex)], ['query']),
      'getTokenStatistics' : IDL.Func([], [TokenStatistics], ['query']),
      'getAllMetaData' : IDL.Func(
        [IDL.Nat],
        [IDL.Vec(IDL.Tuple(TokenIndex, IDL.Text))],
        ['query'],
      ),

    });
    };

    const financeFactory = ({ IDL }) => {

      const TokenPrice_2 = IDL.Record({
        'accountID' : IDL.Text,
        'price' : IDL.Nat64,
      });
      const TokenPrice = TokenPrice_2;
      return IDL.Service({
        'getDiscountPrice' : IDL.Func([], [IDL.Nat64], ['query']),
        'getPrice' : IDL.Func([], [IDL.Nat64], ['query']),
        'isWhiteListed' : IDL.Func([IDL.Principal], [TokenPrice], []),
        'claimedPrincipal' : IDL.Func([], [], []),
        'isClaimed' : IDL.Func([IDL.Principal], [IDL.Bool], ['query']),
        'getAccountIndex' : IDL.Func(
          [IDL.Principal],
          [IDL.Opt(IDL.Nat)],
          ['query'],
        ),
      });
      };
      
    const ledgerFactory = ({ IDL }) => {
      const AccountIdentifier = IDL.Text;
      const Duration = IDL.Record({ 'secs' : IDL.Nat64, 'nanos' : IDL.Nat32 });
      const ArchiveOptions = IDL.Record({
        'max_message_size_bytes' : IDL.Opt(IDL.Nat32),
        'node_max_memory_size_bytes' : IDL.Opt(IDL.Nat32),
        'controller_id' : IDL.Principal,
      });
      const ICPTs = IDL.Record({ 'e8s' : IDL.Nat64 });
      const LedgerCanisterInitPayload = IDL.Record({
        'send_whitelist' : IDL.Vec(IDL.Tuple(IDL.Principal)),
        'minting_account' : AccountIdentifier,
        'transaction_window' : IDL.Opt(Duration),
        'max_message_size_bytes' : IDL.Opt(IDL.Nat32),
        'archive_options' : IDL.Opt(ArchiveOptions),
        'initial_values' : IDL.Vec(IDL.Tuple(AccountIdentifier, ICPTs)),
      });
      const AccountBalanceArgs = IDL.Record({ 'account' : AccountIdentifier });
      const CanisterId = IDL.Principal;
      const HeaderField = IDL.Tuple(IDL.Text, IDL.Text);
      const HttpRequest = IDL.Record({
        'url' : IDL.Text,
        'method' : IDL.Text,
        'body' : IDL.Vec(IDL.Nat8),
        'headers' : IDL.Vec(HeaderField),
      });
      const HttpResponse = IDL.Record({
        'body' : IDL.Vec(IDL.Nat8),
        'headers' : IDL.Vec(HeaderField),
        'status_code' : IDL.Nat16,
      });
      const SubAccount = IDL.Vec(IDL.Nat8);
      const BlockHeight = IDL.Nat64;
      const NotifyCanisterArgs = IDL.Record({
        'to_subaccount' : IDL.Opt(SubAccount),
        'from_subaccount' : IDL.Opt(SubAccount),
        'to_canister' : IDL.Principal,
        'max_fee' : ICPTs,
        'block_height' : BlockHeight,
      });
      const Memo = IDL.Nat64;
      const TimeStamp = IDL.Record({ 'timestamp_nanos' : IDL.Nat64 });
      const SendArgs = IDL.Record({
        'to' : AccountIdentifier,
        'fee' : ICPTs,
        'memo' : Memo,
        'from_subaccount' : IDL.Opt(SubAccount),
        'created_at_time' : IDL.Opt(TimeStamp),
        'amount' : ICPTs,
      });
      return IDL.Service({
        'account_balance_dfx' : IDL.Func([AccountBalanceArgs], [ICPTs], ['query']),
        'get_nodes' : IDL.Func([], [IDL.Vec(CanisterId)], ['query']),
        'http_request' : IDL.Func([HttpRequest], [HttpResponse], ['query']),
        'notify_dfx' : IDL.Func([NotifyCanisterArgs], [], []),
        'send_dfx' : IDL.Func([SendArgs], [BlockHeight], []),
      });
    };

    function loadAnimation()
    {
      document.getElementById("loader").classList.add("lds-facebook");
    }
 
    function unloadAnimation()
    {
      document.getElementById("loader").classList.remove("lds-facebook");
    }
    
    function findAndReplace(string, target, replacement) 
    {
      var i = 0, length = string.length;
      for (i; i < length; i++) {
        string = string.replace(target, replacement);
      }
      return string;
    }    
   

/********************************************************************/
  function log(msg) 
  {
      document.getElementById("logtxt").style.display = "block";
      var div = document.getElementById('logtxt');
      div.innerHTML += msg + "<br>";
  }
  function templog(msg) 
  {
    var display=false;
    if(display)
    {
      document.getElementById("logtxt").style.display = "block";
      var div = document.getElementById('logtxt');
      div.innerHTML += msg + "<br>";
    }
  }  
/******************* Payment method start here *********************/
async function  connectStoicWallet()
{

  try
  {
      identity = await StoicIdentity.connect();

      principalId = identity.getPrincipal();

      document.getElementById("principal").innerHTML = principalId;

      log("Connection to Stoic wallet successful!");
      log("Your Stoic Wallet Principal is " + principalId);


      currentConnectWallet = 1;  //Step-1

      createFactory(currentConnectWallet)  // Connect to Stoic-Walllet
      .then(output => getUserTokens())
      .then(output => getAllMetaData())
      .then(output1 => getAvailableNFT())
      .then(output2 => getMintFee())
      .then(output2 => createLedger(currentConnectWallet))
      .then(output2 => getBalance())
      .then(finalResult => {
        console.log("The final result thing"+finalResult);
      })
      .catch()
      {
        console.log("Some error"); 
      }

      console.log(MarsPoolNFTActor);
      console.log(financeActor);
  } 
  catch (error) {
    log("Exception in StoicIdentity.connect "+ error);
    return -1;
  }  
}
async function  connectPlugWallet()
{
  try
  {
      // Make the request
      const isConnected = await window.ic.plug.requestConnect({
        whitelist,
        host,
      });
      
      // Get the user principal id
      principalId = await window.ic.plug.agent.getPrincipal();

      document.getElementById("principal").innerHTML = principalId;

      log("Connection to Plug wallet successful!");
      log("Your Plug Wallet Principal is " + principalId);

      currentConnectWallet = 2;  //Step-1

      createFactory(currentConnectWallet)  // Connect to Plug-Walllet 
      .then(output => getUserTokens())
      .then(output => getAllMetaData())
      .then(output1 => getAvailableNFT())
      .then(output2 => getMintFee())
      .then(output2 => createLedger(currentConnectWallet))
      .then(output2 => getBalance())
      .then(finalResult => {
        console.log("The final result thing"+finalResult);
      })
      .catch()
      {
        console.log("Some error"); 
      }

      console.log(MarsPoolNFTActor);
      console.log(financeActor);
  } 
  catch (error) {
    log("Exception in StoicIdentity.connect "+ error);
    return -1;
  }  
}

/*************************************************************************/
async function getBalance()
{
  var from_sa = 0;
  const transferFrom = document.getElementById("principal").innerHTML;
  var transferFromAccount = principalToAccountIdentifier(transferFrom,from_sa);
 
  console.log(transferFrom);
  console.log(transferFromAccount);

  var balanceArgs = {
    "account" : transferFromAccount
  };  

  var balance = await ledgerActor.account_balance_dfx(balanceArgs);
  console.log("Balance Amount");
  console.log(balance);

  var balanceBigAmount = balance.e8s - 10000n;
  var a = new BigDecimal(mintFee);
  var b = new BigDecimal(decimals);

  var final = a.divide(b);
 
  log("Your mint fee is "+  final + " ICP only!");
  document.getElementById("mintFee").innerHTML = "Your mint fee is "+  final + " ICP only!";                     

  var c = new BigDecimal(balanceBigAmount);
  balanceICP = c.divide(b);
  
  templog("Balance in your Wallet " + balanceICP + " ICP");
 
  if(balanceICP > final)
  {
    templog("Current Wallet " + currentConnectWallet);
    //Step-200 Now check the Seed
    //await checkMetaData();

    document.getElementById("load").style.display = "none";
    document.getElementById("seed").style.display = "block";
    document.getElementById("checknow").style.display = "block";
    document.getElementById("wallet").value = currentConnectWallet;

    if(currentConnectWallet == 1)
    {
      //log("You are ready to mint your NFT with Stoic Wallet!");
      //document.getElementById("mintnow").innerHTML = "Mint now with Stoic Wallet";
      //document.getElementById("mintnow").style.display = "block";        
    }
    else
    {
      //log("You are ready to mint your NFT with Plug Wallet!");
      //document.getElementById("mintnow").innerHTML = "Mint now with Plug-Wallet";
      //document.getElementById("mintnow").style.display = "block";        
    }
  }
  else
  {
    log("Insufficient balance.");
    document.getElementById("mintnow").innerHTML = "Mint disabled";
    document.getElementById("mintnow").style.display = "none";  
  }
}
/*************************************************************************/
async function getAvailableNFT() {
  var timer = setInterval(async function() {

    if(MarsPoolNFTActor != null)
    {
      var tokenStatistics = await MarsPoolNFTActor.getTokenStatistics(); //Step-2

      var supply = new BigDecimal(tokenStatistics.supply);
      var claimed = new BigDecimal(tokenStatistics.claimed);
    
      var available = (supply - claimed);
      console.log(available);
      //document.getElementById("nft_available").innerHTML = available + " NFTs available.";
      document.getElementById("nft_available").innerHTML = claimed + " NFTs claimed.";
   
    }
  }, 5000);
};
/*************************************************************************/

async function createFactory(walletType)
{
  if(walletType == 2)
  {
    financeActor = await window.ic.plug.createActor({
      canisterId: financeCanisterID,
      interfaceFactory: financeFactory,
    });  
  
    MarsPoolNFTActor = await window.ic.plug.createActor({
      canisterId: MarsPoolNFTId,
      interfaceFactory: MarsPoolNFTFactory,
    });  
  }
  if(walletType == 1)
  {
    financeActor = Actor.createActor(financeFactory, {
      agent: new HttpAgent({
        identity: identity,
        host: "https://mainnet.dfinity.network",
      }),
      canisterId: financeCanisterID,
    }); 
  
    MarsPoolNFTActor = Actor.createActor(MarsPoolNFTFactory, {
      agent: new HttpAgent({
        identity: identity,
        host: "https://mainnet.dfinity.network",
      }),
      canisterId: MarsPoolNFTId,
    }); 
  }  
};
/*************************************************************************/

/*************************************************************/
async function checkMetaData()
{
  /*
  var metadata = document.getElementById("seed").value;
  metaDataList = document.getElementById("allmetadata").value;

  let result = metaDataList.includes(metadata);
  templog("Comparing metadata and list" + metadata + " Result =" + result);

  if(result)
  {
    document.getElementById("error").innerHTML = "Musical SEED already in use, conisder different SEED";
    document.getElementById("mintnow").style.display = "none";
    templog("Word is used");

  }
  else
  {
    templog("Word is not used");
    document.getElementById("error").innerHTML  = "";
    document.getElementById("mintnow").style.display = "block";
  }
  templog(metaDataList.length);
  templog(metaDataList);  
  */
}
/*************************************************************/
async function getMetaData()
{
  templog(principalId);
  var currentUser = {
    principal: principalId,
  };  
  
  metaDataList = await MarsPoolNFTActor.getAllMetaData(5871); 
  
  document.getElementById("allmetadata").value = metaDataList;
}
/*************************************************************/
async function getAllMetaData() {
  var timer = setInterval(async function() {

    if(MarsPoolNFTActor != null)
    {

      getMetaData()   
      .then(output2 => checkMetaData())
      .then(finalResult => {
        console.log("The final result thing"+finalResult);
      })
      .catch()
      {
        console.log("Some error"); 
      }
    }
  }, 5000);
};
/*************************************************************************/
async function getUserTokens()
{

  //principalId = document.getElementById("principal").innerHTML;
  templog(principalId);
  var currentUser = {
    principal: principalId,
  };  
  
  var userTokens = await MarsPoolNFTActor.user_tokens(currentUser); //Step-2
  templog(userTokens.length);

  if(userTokens.length > 0)
  {
    
    var linebreak =0;
    link = "";
    for (let i = 0; i < userTokens.length; i++) 
    {
      
      //link += "<a href='"+userTokens[i]+"'>Token " + userTokens[i] + "<a>";
      link += "<font class='drawing-error'> Token-"+ userTokens[i] + "</font>";
      linebreak++;

      if(linebreak == 9)
      {
        linebreak += "<br>";
      }
      else
      {
        link += ",";
      }
    }    
    document.getElementById("usertokens").innerHTML = "Your Audio visual NFT's : " + link;
  }
};
/*************************************************************************/
async function createLedger(walletType)
{
  if(walletType == 2) //Plug-wallet
  {
    ledgerActor = await window.ic.plug.createActor({
      canisterId: LEDGER_CANISTER_ID,
      interfaceFactory: ledgerFactory,
    }); 
  }
  if(walletType == 1)  //StoicWallet
  {
    //Create an actor canister
    ledgerActor = Actor.createActor(ledgerFactory, {
      agent: new HttpAgent({
        identity: identity,
        host: "https://mainnet.dfinity.network",
      }),
      canisterId: LEDGER_CANISTER_ID,
    }); 
  }
}
/*************************************************************************/
async function getMintFee() {
    log("Getting the mint fee for the NFT....");

    let whiteListResult = await financeActor.isWhiteListed(principalId);

    console.log(whiteListResult.price);

    mintFee = whiteListResult.price;
    transferAccountID = whiteListResult.accountID;

    templog(transferAccountID);
    templog(mintFee);  
};
/*************************************************************************/
document.getElementById("plug-wallet").addEventListener("click", async () => 
{
   

   log("Connecting to Plug Wallet....");
   document.getElementById("mintnow").style.display = "none";
   connectPlugWallet();

   document.getElementById("stoic-wallet").disabled = true;

   document.getElementById("checknow").disabled;
   var disabled = document.getElementById("seed").disabled;
   
   if (disabled) {
      if(currentConnectWallet == 1)
      {
        templog("You are ready to mint your NFT with Stoic Wallet!");
        document.getElementById("mintnow").innerHTML = "Mint now with Stoic Wallet";
        document.getElementById("mintnow").style.display = "block";        
      }
      else
      {
        templog("You are ready to mint your NFT with Plug Wallet!");
        document.getElementById("mintnow").innerHTML = "Mint now with Plug-Wallet";
        document.getElementById("mintnow").style.display = "block";        
      }         
   }

});  
document.getElementById("stoic-wallet").addEventListener("click", async () => 
{
  log("Connecting to Stoic Wallet....");
  document.getElementById("mintnow").style.display = "none";
  connectStoicWallet();

  document.getElementById("plug-wallet").disabled = true;

  var disabled = document.getElementById("seed").disabled;
  if (disabled) {
    if(currentConnectWallet == 1)
    {
      templog("You are ready to mint your NFT with Stoic Wallet!");
      document.getElementById("mintnow").innerHTML = "Mint now with Stoic Wallet";
      document.getElementById("mintnow").style.display = "block";        
    }
    else
    {
      templog("You are ready to mint your NFT with Plug Wallet!");
      document.getElementById("mintnow").innerHTML = "Mint now with Plug-Wallet";
      document.getElementById("mintnow").style.display = "block";        
    }    
  }
});

 
document.getElementById("mintnow").addEventListener("click", async () => 
{
  console.log(currentConnectWallet);

  if(!isMintedFlag)
  {
    mintNFT(); 
  }
  else
  {
    location.reload();
  }
  
});


/*************************************************************************/

/****************************** mintnow **********************************/
async function  mintNFT()
{

  var from_sa = 0;
  var proceed = true;
  var BlockHeight = 0;

  // Step-3
  log("Payment initiated....");

  templog(transferAccountID);
  templog(mintFee);


  if(mintProgress)
  {
    log("Already another transaction in progress!");
    return true;
  }
  
  mintProgress = true;

  // Plug-Wallet vwwmp-om32r-tgzpy-3lx3m-a5qbm-5pst6-xfdoi-gtivj-trcp6-k3dch-5ae
  const transferTo = "vwwmp-om32r-tgzpy-3lx3m-a5qbm-5pst6-xfdoi-gtivj-trcp6-k3dch-5ae";
  // Stoic-Wallet vwwmp-om32r-tgzpy-3lx3m-a5qbm-5pst6-xfdoi-gtivj-trcp6-k3dch-5ae
  //transferAccountID = principalToAccountIdentifier(transferTo,0);
  
  templog("Below is the original account ID that will get the ICP " + transferAccountID);
  templog("Mint Fee in Plug Wallet " + mintFee);  

  //const parameterAccountID = principalToAccountIdentifier(transferTo,1);
  
  const parameterAccountID = transferAccountID;
  templog(parameterAccountID);

   // First Account ID 
  const transferFrom = document.getElementById("principal").innerHTML;
  var transferFromAccount = principalToAccountIdentifier(transferFrom,from_sa);
 
  templog(transferFrom);
  templog(transferFromAccount);

  var balanceArgs = {
    "account" : transferFromAccount
  };

  templog("Checking the balance of the wallet");
  var balance = await ledgerActor.account_balance_dfx(balanceArgs);  //Plug-Wallet
  templog("Balance  " + (balance.e8s/10000000n));

  templog(transferTo + "Transfer to Account  "+transferAccountID);
  templog(transferFrom + " Transfer from account "+transferFromAccount);

  var transfer = balance.e8s - 10000n;

  templog("Transfer Fee " + transfer);
  templog("Mint Fee " + mintFee);
 
  proceed = true;
  if(transfer < mintFee)
  {
    log("Insufficient Balance");
    document.getElementById("error").innerHTML = "Insufficient balance!"; 
    mintProgress = false;           
    return false;
  }

  templog("---- Mint Fee "+ mintFee + "transfer from "+ transferFrom + " to the account "+ transferAccountID);

  var a = new BigDecimal(mintFee);
  var b = new BigDecimal(decimals);

  var final = a.divide(b);

  popupS.alert({
    title:   'MarsPool NFT mint confirmation',
    content: 'You are about to pay '+ final +' ICP'
  });

   var args = {
    "from_subaccount" : [getSubAccountArray(from_sa ?? 0)], 
    "to" : transferAccountID,
    "amount" : { "e8s" : mintFee},
    "fee" : { "e8s" : 10000n }, 
    "memo" : 1  , 
    "created_at_time" : []
  }  
  if(proceed) 
  {
    BlockHeight = await ledgerActor.send_dfx(args);
    log("Transaction successful!");
    templog(BlockHeight);
    mintProgress = false;  

    templog("Claim Process is progress...");

    var rarity = document.getElementById("art_seed").value;
	  var temp_metadata = document.getElementById("seed").value;

    var metadata = findAndReplace(temp_metadata, " ", "_")
    templog("Meta Data " + metadata);

    var claimRequest = {
      metadata: metadata,
      amountPaid: mintFee,
      account: transferAccountID,
      blockHeight: BlockHeight,
      rarity: rarity,
    };

    templog(claimRequest);

    log("NFT Claim is in progress...");
    var isMinted = await MarsPoolNFTActor.claimNFT(claimRequest);
    log("NFT is claimed ");
    templog(isMinted); 

    isMintedFlag = true;

    await financeActor.claimedPrincipal();
    
    link = document.getElementById("usertokens").innerHTML;
    //link += "<a href='"+ isMinted +"'>Token " + isMinted + "<a>";
    link += "<font class='drawing-error'> Token-"+ isMinted + "</font>";

    document.getElementById("usertokens").innerHTML = link;    
  }
  else
  {
    log("You have cancelled the transaction"); 
    document.getElementById("error").innerHTML = "You have cancelled the transaction";  
    mintProgress = false;  

    popupS.alert({
      title:   'MarsPool NFT mint result',
      content: 'You have cancelled the transaction!'
    });                     
  }
  mintProgress = false;  
}
/***************************************************************************/
const principalToAccountIdentifier = (p, s) => {
  const padding = Buffer("\x0Aaccount-id");
  const array = new Uint8Array([
      ...padding,
      ...Principal.fromText(p).toUint8Array(),
      ...getSubAccountArray(s)
  ]);
  const hash = sha224(array);
  const checksum = to32bits(getCrc32(hash));
  const array2 = new Uint8Array([
      ...checksum,
      ...hash
  ]);
  return toHexString(array2);
};
/***************************************************************************/
const toHexString = (byteArray)  =>{
  return Array.from(byteArray, function(byte) {
    return ('0' + (byte & 0xFF).toString(16)).slice(-2);
  }).join('')
}
/***************************************************************************/
const to32bits = num => {
  let b = new ArrayBuffer(4);
  new DataView(b).setUint32(0, num);
  return Array.from(new Uint8Array(b));
};
const fromHexString = (hex) => {
  if (hex.substr(0,2) === "0x") hex = hex.substr(2);
  for (var bytes = [], c = 0; c < hex.length; c += 2)
  bytes.push(parseInt(hex.substr(c, 2), 16));
  return bytes;
};
/***************************************************************************/
const getSubAccountArray = (s) => {
  if (Array.isArray(s)){
    return s.concat(Array(32-s.length).fill(0));
  } else {
    //32 bit number only
    return Array(28).fill(0).concat(to32bits(s ? s : 0))
  }
};
/******************* Payment method end heres *********************/

/************************************************************/
// Utility functions
// Given a processing object, a loop length, a radius, and an offset (optional)
function getLoopingNoise({p, loopLength, radius, offset=0}) {
	let t = p.millis()
	

	// This number should go from 0 to 1 every loopLength seconds
	// And PI*2 radians every loopLength seconds
	let noiseScale = 1
	let loopPct = (t*.001/loopLength)%1 

	let theta = 2*Math.PI*loopPct

	// Place to sample the noise from
	let x = radius*Math.cos(theta)
	let y = radius*Math.sin(theta)

	let noiseVal = p.noise(x*noiseScale, y*noiseScale, offset)
	return noiseVal
}


function getP5Element(index) {
	let element = document.getElementById("drawing" + index).getElementsByClassName("drawing-p5holder")[0]
	return element
}

//===========================================================

const WIDTH = 300
const HEIGHT = 300


// Run this function after the page is loaded
//document.addEventListener("DOMContentLoaded", function(){
document.getElementById("load").addEventListener("click", function (e) {

  if(animationCreated)
  {
    return; // We need to change only the music
  }
  document.getElementById("load").style.display = "none";
  

	// Rename your drawing here if you want
	let drawingTitles = ["Infinite scalability", 
		"Security has a system of checks that are superior to Ethereum’s.", 
		"Compatible with smart contracts so decentralized applications (dapps) can be built on the platform.", 
		"Highly experienced team"
    	]
	let mainElement = document.getElementById("main")
    let NFTCounter = 0;
		
	// Ignore this section if you want
	// This is me adding a label and a canvas-holder to each swatch
	// For each drawing
    let color = Math.floor((Math.random() * 120) + 10);
    console.log(color);

    let bgcolor = Math.floor((Math.random() * 9) + 1);
    let sides = Math.floor((Math.random() * 15) + 2);
    let dots = Math.floor((Math.random() * 25) + 1);
    let centercolor = Math.floor((Math.random() * 5) + 1);

    var args = '{"color":'+color+', "bgcolor":'+bgcolor+', "sides":'+sides+',"centercolor":'+centercolor+', "dots":'+dots+'}';
    console.log(args);

    var userSeed = document.getElementById("art_seed").value;

    if(userSeed.length > 10)
    {
      args = userSeed;
    }
    //args = '{"color":38, "bgcolor":7, "sides":8,"centercolor":3, "dots":7}';

    document.getElementById("art_seed").value = args;

	for (var i = 0; i < 1; i++)
    {
		let el = document.createElement("div")
		el.className = "drawing"
		el.id = "drawing" + i
		mainElement.append(el)


		// Add a label
		let label = document.createElement("div")
		label.className = "drawing-label"
		label.innerHTML = "MarsPoolNFT , Mint if you like it"; // + i + ":" + args //drawingTitles[i]
		el.append(label)
        NFTCounter++;

		// Add a div to hold the canvas (so we can resize it independently of the outer frame)
		let canvasHolder = document.createElement("div")
		canvasHolder.className = "drawing-p5holder"
		canvasHolder.style = `width:${WIDTH};height:${HEIGHT}`
		el.append(canvasHolder)
	}

	// Comment out these lines to not draw each
    setupDrawing3(args);

    document.getElementById("play").click();

    animationCreated = true;
});



function setupDrawing3(arg_sides) {

	function setup(p) {
		p.createCanvas(WIDTH, HEIGHT);
        p.id = "drawing";
		p.colorMode(p.HSL);
        p.background(0);  //Parameter
 	}

	function draw(p) {

        const centercolor = ["red", "orange","white","green", "yellow", "blue","#00FFFF"];


        const colors = [
            "AliceBlue",
            "AntiqueWhite",
            "Aqua",
            "Aquamarine",
            "Azure",
            "Beige",
            "Bisque",
            "Black",
            "BlanchedAlmond",
            "Blue",
            "BlueViolet",
            "Brown",
            "BurlyWood",
            "CadetBlue",
            "Chartreuse",
            "Chocolate",
            "Coral",
            "CornflowerBlue",
            "Cornsilk",
            "Crimson",
            "Cyan",
            "DarkBlue",
            "DarkCyan",
            "DarkGoldenRod",
            "DarkGray",
            "DarkGrey",
            "DarkGreen",
            "DarkKhaki",
            "DarkMagenta",
            "DarkOliveGreen",
            "DarkOrange",
            "DarkOrchid",
            "DarkRed",
            "DarkSalmon",
            "DarkSeaGreen",
            "DarkSlateBlue",
            "DarkSlateGray",
            "DarkSlateGrey",
            "DarkTurquoise",
            "DarkViolet",
            "DeepPink",
            "DeepSkyBlue",
            "DimGray",
            "DimGrey",
            "DodgerBlue",
            "FireBrick",
            "FloralWhite",
            "ForestGreen",
            "Fuchsia",
            "Gainsboro",
            "GhostWhite",
            "Gold",
            "GoldenRod",
            "Gray",
            "Grey",
            "Green",
            "GreenYellow",
            "HoneyDew",
            "HotPink",
            "IndianRed",
            "Indigo",
            "Ivory",
            "Khaki",
            "Lavender",
            "LavenderBlush",
            "LawnGreen",
            "LemonChiffon",
            "LightBlue",
            "LightCoral",
            "LightCyan",
            "LightGoldenRodYellow",
            "LightGray",
            "LightGrey",
            "LightGreen",
            "LightPink",
            "LightSalmon",
            "LightSeaGreen",
            "LightSkyBlue",
            "LightSlateGray",
            "LightSlateGrey",
            "LightSteelBlue",
            "LightYellow",
            "Lime",
            "LimeGreen",
            "Linen",
            "Magenta",
            "Maroon",
            "MediumAquaMarine",
            "MediumBlue",
            "MediumOrchid",
            "MediumPurple",
            "MediumSeaGreen",
            "MediumSlateBlue",
            "MediumSpringGreen",
            "MediumTurquoise",
            "MediumVioletRed",
            "MidnightBlue",
            "MintCream",
            "MistyRose",
            "Moccasin",
            "NavajoWhite",
            "Navy",
            "OldLace",
            "Olive",
            "OliveDrab",
            "Orange",
            "OrangeRed",
            "Orchid",
            "PaleGoldenRod",
            "PaleGreen",
            "PaleTurquoise",
            "PaleVioletRed",
            "PapayaWhip",
            "PeachPuff",
            "Peru",
            "Pink",
            "Plum",
            "PowderBlue",
            "Purple",
            "RebeccaPurple",
            "Red",
            "RosyBrown",
            "RoyalBlue",
            "SaddleBrown",
            "Salmon",
            "SandyBrown",
            "SeaGreen",
            "SeaShell",
            "Sienna",
            "Silver",
            "SkyBlue",
            "SlateBlue",
            "SlateGray",
            "SlateGrey",
            "Snow",
            "SpringGreen",
            "SteelBlue",
            "Tan",
            "Teal",
            "Thistle",
            "Tomato",
            "Turquoise",
            "Violet",
            "Wheat",
            "White",
            "WhiteSmoke",
            "Yellow",
            "YellowGreen",
          ];  
          
          
        const bgcolors = ["#13274F","#B5A642","#002244","#002E63","#3D2B1F","#000000","#612302","#00308F","#32174d","#343434","#002fa7"];



        const obj = JSON.parse(arg_sides);


		// Or try it with trails
		p.background(bgcolors[obj.bgcolor]);  //Parameter
            
		let t = p.frameCount *.01


		
		// Sometimes its easiest to translate into the center of the screen
		// so that the origin (0,0) is at the center and not the top left
		p.push()
		p.translate(p.width/2, p.height/2)

		p.noStroke()
		p.fill(centercolor[obj.centercolor]) // Center Point

		// See? The (0,0) point is now in the center of the screen
		p.circle(0, 0, 10, 10)


		let sides = obj.sides;

		// To make mandalas or other forms of repetition, 
		// run your drawing function *multiple times*

		// Here, I'm running it "sides" times, 
		// and each time, rotating a little more
		// to create a flower shape
		for (var i = 0; i < sides; i++) {
			
			p.rotate(Math.PI*2/sides)   

			
			// Create a number of dots that are positioned with noise
			let dotCount = obj.dots; // Parameter  2


              

			var col = obj.color; // Parameter
            var start = col;
            var end = start+10;

			for (var j = 0; j < dotCount; j++) {
				let offsetX = 200*p.noise(t + 50, j*.1) - 80
				let offsetY = 300*p.noise(t + 30, j*.1) - 80
				
				let hue = 115*j/sides
				p.fill(hue, 3, 30 + 60*j/dotCount, .25)
				p.circle(offsetX, offsetY - 2, 2)
				p.fill(colors[col])
				p.circle(offsetX, offsetY, 5)
				
				col++;
                
				if(col > end)
				{
					col = start;
				}
			}
		
		}
		p.pop()
		
	}


	let element = getP5Element(0) // <- Make sure to change this to the right index

	let myP5 = new p5(function(p) {
		p.setup = () => setup(p)
		p.draw = () => draw(p)
	}, element);
}

/********************************************************** */
class BigDecimal {
  constructor(value) {
      let [ints, decis] = String(value).split(".").concat("");
      decis = decis.padEnd(BigDecimal.decimals, "0");
      this.bigint = BigInt(ints + decis);
  }
  static fromBigInt(bigint) {
      return Object.assign(Object.create(BigDecimal.prototype), { bigint });
  }
  divide(divisor) { // You would need to provide methods for other operations
      return BigDecimal.fromBigInt(this.bigint * BigInt("1" + "0".repeat(BigDecimal.decimals)) / divisor.bigint);
  }
  toString() {
      const s = this.bigint.toString().padStart(BigDecimal.decimals+1, "0");
      return s.slice(0, -BigDecimal.decimals) + "." + s.slice(-BigDecimal.decimals)
              .replace(/\.?0+$/, "");
  }
}
BigDecimal.decimals = 18; // Configuration of the number of decimals you want to have.

